import { string, number, bool, arrayOf, shape } from 'prop-types';

/**
 * Skjema definisjon for data som brukes i KDKForm
 * Følger struktur definert i felles-kjenndinkunde-portal sitt REST-API
 */

export const UnderSporsmal = {
    definisjon: string,
    eksternId: string,
    instruks: string,
    prikkerGitt: number,
    sporsmalstekst: string,
    svartekst: string,
    synlighet: string,
    type: string,
    utfyllingsregel: shape({
        regel: string,
    }),
    valideringsMonster: string,
};

export const MuligSvar = {
    prikkerGitt: number,
    svarId: string,
    tekst: string,
    valgt: bool,
    undersporsmal: arrayOf(shape(UnderSporsmal)),
};

export const SkjemaSporsmal = {
    config: shape({
        textNoWhitespace: bool,
        formaterHTML: bool,
        aktorListHideLabel: bool,
        aktorListHideIndex: bool,
        aktorListMaxLength: number,
    }),
    definisjon: string,
    eksternId: string,
    instruks: string,
    muligeSvar: arrayOf(shape(MuligSvar)),
    sporsmalstekst: string,
    synlighet: string,
    type: string,
    utfyllingsregel: shape({
        regel: string,
    }),
};

export const Skjema = {
    skjematype: string,
    skjemaSporsmal: arrayOf(shape(SkjemaSporsmal)),
};

export const AktivVurdering = {
    eier: shape({
        value: string,
    }),
    registreringsprosess: string,
    gjeldendeVurdering: string,
    erklaringtype: string,
    skjema: shape(Skjema),
};
